import { isEqual } from "lodash";
import { useState } from "react";

export interface UseAppliedFilters<T> {
  readonly draft: T;
  readonly applied: T;
  readonly isDirty: boolean;
  readonly setDraft: (next: T) => void;
  readonly apply: () => void;
}

/** Stages filter edits locally in `draft` without affecting `applied` until `apply()` is called, so a
 * query bound to `applied` only refetches when the user explicitly applies the pending changes. */
export function useAppliedFilters<T>(initial: T | (() => T)): UseAppliedFilters<T> {
  const [draft, setDraft] = useState<T>(initial);
  const [applied, setApplied] = useState<T>(initial);
  return {
    draft,
    applied,
    isDirty: !isEqual(draft, applied),
    setDraft,
    apply: () => setApplied(draft),
  };
}
